import { createDate } from '@unistocks/shared/utils/util';
import { DateRange } from '@unistocks/types';
import { TimeSeriesEntry } from '@unistocks/types/time-series';
import { useMemo } from 'react';
import { groupDataItems, GroupDataOptions, resolveGroupBy } from './chart-data';

export const useGroupData = <T extends TimeSeriesEntry>(
  rawData: T[],
  options: GroupDataOptions = {}
) => {
  const { groupBy, groupValue = 'average' } = options;

  return useMemo(() => {
    let resolvedGroupBy = groupBy;
    if (!resolvedGroupBy) {
      if (rawData.length >= 2) {
        const dateRange: DateRange = [
          createDate(rawData[0].timestamp),
          createDate(rawData.at(-1)!.timestamp)
        ];
        resolvedGroupBy = resolveGroupBy(dateRange);
      } else {
        resolvedGroupBy = 'day';
      }
    }

    return {
      values: groupDataItems(rawData, { groupBy: resolvedGroupBy, groupValue }),
      groupBy: resolvedGroupBy
    };
  }, [groupBy, rawData, groupValue]);
};
